export default "__VITE_ASSET__D754X5FV__"